import React from "react";
import { useSelector } from "react-redux";

import IconHide from "./IconHide";
import IconLock from "./IconLock";

import { getTranslation } from "../../utils/helper";

const DriverTime = ({
  hours,
  driverIdsLock,
  driverIdsHide,
  onClickLock,
  onClickHide,
  setting,
  oneHourPx,
  clickTimeLine,
  nonTimeRef,
  stateTimeLine,
  timeLineRef,
}) => {
  const { user } = useSelector(state => state.auth);
  const canEdit = !user?.roles?.includes("user");

  const isLock = driverIdsLock.includes("all-drivers");
  const isHide = driverIdsHide.includes("all-drivers");

  const handleClickTime = e => {
    const rect = e.currentTarget.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    clickTimeLine && clickTimeLine(offsetX);
    console.log(`Clicked at ${offsetX}px from the left of the div`);
  };

  return (
    <div
      className="tr"
      style={{
        minWidth: (hours.length + 1) * oneHourPx,
        width: "100%",
      }}>
      <div className="td" ref={nonTimeRef}>
        <div className="driver-name all-drivers">
          {canEdit && <IconLock isLock={isLock} onClickLock={() => onClickLock("all-drivers")} />}
          <IconHide isHide={isHide} onClickHide={() => onClickHide("all-drivers")} />
          <b>{getTranslation(setting, "Route Plans", "Drivers")}</b>
        </div>
        <div
          style={{
            width: "150px",
            display: "flex",
            alignItems: "center",
          }}
        />
      </div>
      <div
        className="td"
        onClick={handleClickTime}
        style={{ position: "relative", cursor: "s-resize" }}
        ref={timeLineRef}>
        {hours.map((hour, index) => {
          if (oneHourPx < 450) {
            return (
              <div
                className="time"
                key={index}
                style={{
                  width: `${oneHourPx}px`,
                  transition: "width 1s",
                  userSelect: "none",
                }}>
                {String(hour).padStart(2, "0")}:00
              </div>
            );
          }

          if (oneHourPx < 950) {
            return (
              <>
                <div
                  className="time"
                  key={index + "00"}
                  style={{
                    width: `${oneHourPx / 4}px`,
                    transition: "width 1s",
                    userSelect: "none",
                  }}>
                  {String(hour).padStart(2, "0")}:00
                </div>
                <div
                  className="time"
                  key={index + "15"}
                  style={{
                    width: `${oneHourPx / 4}px`,
                    transition: "width 1s",
                    userSelect: "none",
                  }}>
                  {String(hour).padStart(2, "0")}:15
                </div>
                <div
                  className="time"
                  key={index + "30"}
                  style={{
                    width: `${oneHourPx / 4}px`,
                    transition: "width 1s",
                    userSelect: "none",
                  }}>
                  {String(hour).padStart(2, "0")}:30
                </div>
                <div
                  className="time"
                  key={index + "45"}
                  style={{
                    width: `${oneHourPx / 4}px`,
                    transition: "width 1s",
                    userSelect: "none",
                  }}>
                  {String(hour).padStart(2, "0")}:45
                </div>
              </>
            );
          }
          return (
            <>
              {Array.from({ length: 12 }, (_, i) => {
                const minute = String(i * 5).padStart(2, "0");
                return (
                  <div
                    className="time"
                    key={index + minute}
                    style={{
                      width: `${oneHourPx / 12}px`,
                      transition: "width 1s",
                      userSelect: "none",
                    }}>
                    {String(hour).padStart(2, "0")}:{minute}
                  </div>
                );
              })}
            </>
          );
        })}
        {stateTimeLine.maxTimePx && (
          <div
            style={{
              width: 1,
              height: "100%",
              position: "absolute",
              backgroundColor: "red",
              left: stateTimeLine.maxTimePx,
            }}></div>
        )}
        {stateTimeLine.minTimePx && (
          <div
            style={{
              width: 1,
              height: "100%",
              position: "absolute",
              backgroundColor: "red",
              left: stateTimeLine.minTimePx,
            }}></div>
        )}
      </div>
    </div>
  );
};

export default DriverTime;
